// dashboard.js (con la letra inicial en el avatar y botón para seleccionar restaurante en el menú)
// Incluye reconexión automática de WebSocket

import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PersonIcon from "@mui/icons-material/Person";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import TableChartIcon from "@mui/icons-material/TableChart";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import CategoryIcon from "@mui/icons-material/Category";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ImageIcon from "@mui/icons-material/Image";
import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from '@mui/icons-material/Settings';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { urlWebSockets } from "../assets/functions_helper";
import {
  Avatar,
  Badge,
  CircularProgress,
  Divider,
  Menu,
  MenuItem,
  SwipeableDrawer,
  Snackbar,
  Alert,
  List as NotificationList,
  ListItemAvatar,
  ListItemText as NotificationListItemText,
  Avatar as NotificationAvatar,
  Tooltip,
  Button
} from "@mui/material";
import ListUsers from "./modules/admin_users/list_users";
import { useNavigate } from "react-router-dom";
import { makeRequest } from "../assets/functions_helper";
import MainRestaurants from "./modules/restaurants/main_restaurants";
import SnackBar from "../components/snackBar";
import LogoLogo from "../assets/images/logoDashboard.png";
import PhoneFlip from "../assets/images/phoneFlip.png";
import { useWindowWidth } from "../hooks/useWindowWidth";
import CallsV2 from "./modules/calls/callV2";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LockIcon from "@mui/icons-material/Lock";
import SelectRestaurantPopup from "./modules/select_restaurant_popup";
import RestaurantAdminPanel from "./modules/restaurants/restaurant_admin_panel";
import RestaurantLocationSettings from "./modules/settings/restaurant_location_settings";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import { Collapse } from "@mui/material";
import { CustomDialog, CustomDialogActions, CustomDialogContent, CustomDialogTitle } from "../components/customDialog";
import { CustomTextField } from "../components/textFields";
import { SendButton } from "../components/buttons";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CreateRestaurantModal from "./modules/restaurants/CreateRestaurantModal";
import BarChartIcon from "@mui/icons-material/BarChart";
import RestaurantStatistics from "./modules/stadistics/restaurant_statistics";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import LinkIcon from '@mui/icons-material/Link';
import AssignmentIcon from '@mui/icons-material/Assignment';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PlanesModule from './modules/planes/planes_module';
import { SubscriptionUsageProvider, useSubscriptionUsage } from '../context/SubscriptionUsageContext';
import { UsageIndicators } from '../components/UsageIndicators';
import { SubscriptionBanner } from '../components/SubscriptionBanner';


const drawerWidth = 280;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth - 10}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 20,
  }),
  marginTop: "120px",
  height: "calc(100vh - 120px)",
  overflowY: "auto",
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px - 30px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  background: "#070724",
  borderRadius: "20px",
  border: "1px black solid",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  height: "90px",
  margin: "10px",
  marginBottom: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  ...theme.mixins.toolbar,
  paddingLeft: "16px",
}));

const DrawerCustomized = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    background: "white",
    color: "white",
    borderRadius: 16,
    margin: "10px",
    boxSizing: "border-box",
    height: "calc(100% - 20px)",
    padding: "16px",
    border: "2px solid #D8D8D8",
  },
}));

function DashBoardContent({ setIsLoggedIn }) {
  const [open, setOpen] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElNotifications, setAnchorElNotifications] = React.useState(null);
  const [anchorElGroup, setAnchorElGroup] = React.useState(null);

  const [activeView, setActiveView] = React.useState("Usuarios");
  const [pagesActiveView, setPagesActiveView] = React.useState(["Usuarios", "Restaurantes", "Admin. Restaurante", "Ajustes"]);

  const [openDialog, setOpenDialog] = React.useState(false);
  const [newPassword, setNewPassword] = React.useState("");
  const [oldPassword, setOldPassword] = React.useState("");
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackBarMessage, setSnackBarMessage] = React.useState("");
  const [loadingChangePassword, setLoadingChangePassword] = React.useState(false);
  const [confirmNewPassword, setConfirmNewPassword] = React.useState("");
  const [selectedRestaurant, setSelectedRestaurant] = React.useState(() => {
    const savedId = localStorage.getItem("selectedRestaurantId");
    const savedName = localStorage.getItem("selectedRestaurantName");
    return savedId && savedName ? { id: parseInt(savedId, 10), name: savedName } : null;
  });
  const [openRestaurantPopup, setOpenRestaurantPopup] = React.useState(false);
  const [adminTabsOpen, setAdminTabsOpen] = React.useState(false);
  const [adminActiveTab, setAdminActiveTab] = React.useState(null);
  const [createModalOpen, setCreateModalOpen] = React.useState(false);

  const [openEditNameDialog, setOpenEditNameDialog] = React.useState(false);
  const [newRestaurantName, setNewRestaurantName] = React.useState("");
  const [loadingEditName, setLoadingEditName] = React.useState(false);

  // Estado separado para el ID del restaurante (solo cambia cuando se selecciona otro restaurante)
  const [currentRestaurantId, setCurrentRestaurantId] = React.useState(() => {
    const savedId = localStorage.getItem("selectedRestaurantId");
    return savedId ? parseInt(savedId, 10) : null;
  });

  // Estados para notificaciones
  const [notifications, setNotifications] = React.useState([]);
  const [unreadCount, setUnreadCount] = React.useState(0);
  const [reservationsBadgeCount, setReservationsBadgeCount] = React.useState(0);
  const [notificationSnack, setNotificationSnack] = React.useState({ open: false, message: "", imageUrl: "" });
  const [productFilter, setProductFilter] = React.useState("");
  const [imageFilter, setImageFilter] = React.useState("");

  // Plan de suscripción activo (obtenido del servidor tras el login)
  const [planTier, setPlanTier] = React.useState(null);

  // Refs para manejar WebSocket y reconexiones
  const socketRef = React.useRef(null);
  const reconnectTimeoutRef = React.useRef(null);
  const reconnectAttemptsRef = React.useRef(0);
  const maxReconnectAttempts = 5;
  const baseReconnectDelay = 1000; // 1 segundo

  const navigate = useNavigate();
  const width = useWindowWidth();

  // Obtener nombre del usuario desde localStorage
  const userName = localStorage.getItem("name") || "Usuario";

  // Cargar configuración inicial según rol y plan de suscripción
  React.useEffect(() => {
    const rol = localStorage.getItem("rol");
    if (rol === "2") {
      setActiveView("Admin. Restaurante");
      // Obtener el plan activo del servidor — nunca desde el cliente
      makeRequest(
        "GET",
        "subscriptions_router/plan_features",
        null,
        "application/json",
        localStorage.getItem("token"),
        localStorage.getItem("tokenType"),
        null,
        true // skipLoader: silencioso, sin bloquear la UI
      )
        .then((data) => {
          const tier = data?.current_tier?.toLowerCase() || "basic";
          setPlanTier(tier);
          // Estadísticas solo se agrega si el servidor confirma plan no-básico
          const hasAdvancedPlan = tier !== "basic";
          setPagesActiveView([
            "Admin. Restaurante",
            "Calls",
            ...(hasAdvancedPlan ? ["Estadísticas"] : []),
            "Planes",
            "Ajustes",
          ]);
        })
        .catch(() => {
          // Si falla la consulta, restringir al mínimo (más seguro)
          setPlanTier("basic");
          setPagesActiveView(["Admin. Restaurante", "Calls", "Planes", "Ajustes"]);
        });
    } else {
      setPagesActiveView(["Calls"]);
      setActiveView("Calls");
    }
  }, []);

  // Abrir acordeón cuando se selecciona un restaurante (solo cuando cambia el ID)
  // Y llamar al contador de uso de suscripción
  const { fetchUsage } = useSubscriptionUsage();

  React.useEffect(() => {
    if (currentRestaurantId) {
      setAdminTabsOpen(true);
      fetchUsage(currentRestaurantId);
    }
  }, [currentRestaurantId, fetchUsage]);

  React.useEffect(() => {
    const handleNavigateAdminTab = (event) => {
      if (event.detail && event.detail.tabName) {
        setActiveView("Admin. Restaurante");
        setAdminActiveTab(event.detail.tabName);
      }
    };
    window.addEventListener("navigateAdminTab", handleNavigateAdminTab);
    return () => {
      window.removeEventListener("navigateAdminTab", handleNavigateAdminTab);
    };
  }, []);

  // Función para conectar WebSocket con lógica de reconexión
  // Ahora recibe el ID del restaurante como parámetro
  const connectWebSocket = React.useCallback((restaurantId) => {
    if (!restaurantId) return;

    const wsUrl = `${urlWebSockets}/websocket_general_notification/${restaurantId}`;

    // Cerrar socket existente antes de crear uno nuevo
    if (socketRef.current) {
      socketRef.current.close();
    }

    const socket = new WebSocket(wsUrl);
    socketRef.current = socket;

    socket.onopen = () => {
      console.log(`✅ WebSocket conectado para restaurante ${restaurantId}`);
      reconnectAttemptsRef.current = 0; // Resetear intentos al conectar exitosamente
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("📩 Notificación recibida:", data);

        // Solo procesar si es image_enhanced
        if (data.notification_type === "image_enhanced" && data.name) {
          // Crear objeto de notificación
          const newNotification = {
            id: Date.now() + Math.random(),
            type: data.type,
            entity_type: data.entity_type,
            entity_id: data.entity_id,
            image_url: data.image_url,
            name: data.name,
            read: false,
            timestamp: new Date().toISOString(),
          };

          // Actualizar lista de notificaciones (máximo 20)
          setNotifications((prev) => [newNotification, ...prev].slice(0, 20));
          setUnreadCount((prev) => prev + 1);

          // Mostrar snackbar con la notificación
          setNotificationSnack({
            open: true,
            message: `✨ Imagen mejorada: ${data.name}`,
            imageUrl: data.image_url,
            productName: data.name,
          });

          // Reproducir sonido
          playNotificationSound();
        } else if (
          ["reservation_received", "reservation_confirmed", "reservation_cancelled", "reservation_rejected"].includes(
            data.notification_type
          )
        ) {
          if (data.notification_type === "reservation_received") {
            // Actualizar badge de reservas
            setReservationsBadgeCount((prev) => prev + 1);
            setNotificationSnack({
              open: true,
              message: `📅 Nueva solicitud de reserva de ${data.customer_name} - ${data.guest_count} personas`,
              imageUrl: null,
              productName: "Nueva Reserva",
            });
          } else if (data.notification_type === "reservation_confirmed") {
            setNotificationSnack({
              open: true,
              message: `✅ Reserva confirmada para ${data.customer_name}`,
              imageUrl: null,
              productName: "Reserva Confirmada",
            });
          } else if (data.notification_type === "reservation_cancelled") {
            setNotificationSnack({
              open: true,
              message: `❌ Reserva cancelada por ${data.customer_name}`,
              imageUrl: null,
              productName: "Reserva Cancelada",
            });
          } else if (data.notification_type === "reservation_rejected") {
            setNotificationSnack({
              open: true,
              message: `🚫 Reserva rechazada de ${data.customer_name}`,
              imageUrl: null,
              productName: "Reserva Rechazada",
            });
          }

          // Reproducir sonido
          playNotificationSound();
          
          // Disparar evento para recargar listas de reservas/Gantt
          window.dispatchEvent(
            new CustomEvent("reload_reservations", {
              detail: { type: data.notification_type, restaurantId: restaurantId },
            })
          );
        }
      } catch (error) {
        console.error("❌ Error al procesar mensaje WebSocket:", error);
      }
    };

    socket.onerror = (error) => {
      console.error("❌ WebSocket error:", error);
    };

    socket.onclose = (event) => {
      console.log(`🔌 WebSocket cerrado para restaurante ${restaurantId}:`, event.reason);

      // Intentar reconectar si no fue un cierre intencional y no se excedieron los reintentos
      if (reconnectAttemptsRef.current < maxReconnectAttempts) {
        const delay = Math.min(baseReconnectDelay * Math.pow(2, reconnectAttemptsRef.current), 32000); // backoff exponencial hasta 32s
        console.log(`🔄 Reintentando conectar en ${delay / 1000} segundos... (intento ${reconnectAttemptsRef.current + 1}/${maxReconnectAttempts})`);

        reconnectTimeoutRef.current = setTimeout(() => {
          reconnectAttemptsRef.current += 1;
          connectWebSocket(restaurantId);
        }, delay);
      } else {
        console.log("⚠️ Máximo número de reintentos alcanzado. No se volverá a conectar.");
      }
    };
  }, []);

  // Función para limpiar recursos de WebSocket
  const cleanupWebSocket = React.useCallback(() => {
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null;
    }
    reconnectAttemptsRef.current = 0;
  }, []);

  // Efecto para manejar WebSocket y reconexión basado en el ID del restaurante
  React.useEffect(() => {
    if (!currentRestaurantId) {
      cleanupWebSocket();
      return;
    }

    connectWebSocket(currentRestaurantId);

    // Cleanup al desmontar o cambiar restaurante
    return () => {
      cleanupWebSocket();
    };
  }, [currentRestaurantId, connectWebSocket, cleanupWebSocket]);

  // Función para reproducir sonido (beep simple)
  const playNotificationSound = () => {
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
      gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.start();
      oscillator.stop(audioContext.currentTime + 0.2);
    } catch (e) {
      console.log("Error reproduciendo sonido:", e);
    }
  };

  // Marcar todas como leídas
  const markAllAsRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
    setUnreadCount(0);
  };

  // Manejar clic en notificación
  const handleNotificationClick = (notification) => {
    // Marcar como leída
    setNotifications((prev) => prev.map((n) => (n.id === notification.id ? { ...n, read: true } : n)));
    setUnreadCount((prev) => Math.max(0, prev - 1));

    // Cerrar menú de notificaciones
    setAnchorElNotifications(null);

    // Determinar tipo de entidad y navegar
    setActiveView("Admin. Restaurante");

    if (notification.entity_type === "background_image") {
      setImageFilter(notification.name);
      setProductFilter(""); // Limpiar filtro de productos
      setAdminActiveTab("Imágenes");
    } else if (notification.entity_type === "product") {
      setProductFilter(notification.name);
      setImageFilter(""); // Limpiar filtro de imágenes
      setAdminActiveTab("Productos");
    } else {
      // Por defecto, si no se reconoce, ir a productos? O ignorar
      console.warn("Tipo de notificación no reconocido:", notification.entity_type);
    }
  };

  // Cerrar snackbar de notificación
  const handleCloseNotificationSnack = () => {
    setNotificationSnack({ ...notificationSnack, open: false });
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleLogOut = () => {
    setAnchorEl(null);
    localStorage.clear();
    setIsLoggedIn(false);
    navigate("/");
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Función para actualizar el nombre del restaurante en el estado
  const handleRestaurantNameUpdate = (newName) => {
    setSelectedRestaurant(prev => ({
      ...prev,
      name: newName
    }));
  };

  const handleEditNameSubmit = () => {
    if (!newRestaurantName.trim()) {
      setSnackBarMessage("El nombre no puede estar vacío");
      setSnackBarOpen(true);
      return;
    }
    setLoadingEditName(true);
    makeRequest(
      "PUT",
      `restaurant_admin/update_restaurant_name/${selectedRestaurant.id}`,
      { name: newRestaurantName.trim() },
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null, null, () => navigate("/login")
    ).then(() => {
      handleRestaurantNameUpdate(newRestaurantName.trim());
      setSnackBarMessage("Nombre actualizado correctamente");
      setSnackBarOpen(true);
      setOpenEditNameDialog(false);
    }).catch((err) => {
      console.error(err);
      setSnackBarMessage("Error al actualizar nombre");
      setSnackBarOpen(true);
    }).finally(() => {
      setLoadingEditName(false);
    });
  };

  const renderView = () => {
    switch (activeView) {
      case "Usuarios":
        return <ListUsers />;
      case "Restaurantes":
        return <MainRestaurants />;
      case "Admin. Restaurante":
        return (
          <RestaurantAdminPanel
            restaurant={selectedRestaurant}
            activeTab={adminActiveTab}
            productFilter={productFilter}
            imageFilter={imageFilter}
            onRestaurantNameUpdate={handleRestaurantNameUpdate}
          />
        );
      case "Ajustes":
        return <RestaurantLocationSettings
          restaurantId={selectedRestaurant?.id}
          onNameUpdate={handleRestaurantNameUpdate}
        />;
      case "Calls":
        return selectedRestaurant ? <CallsV2 restaurantId={selectedRestaurant.id} /> : <></>;
      case "Estadísticas":
        // Doble guarda: el componente solo se monta si el servidor confirmó plan no-básico
        if (planTier === null || planTier === "basic") return null;
        return <RestaurantStatistics restaurantId={selectedRestaurant.id} />;
      case "Planes":
        return <PlanesModule />;
      default:
        return <ListUsers />;
    }
  };

  const handlePasswordChange = () => {
    if (oldPassword === "" || newPassword === "") {
      setSnackBarMessage("Debe llenar todos los campos");
      setSnackBarOpen(true);
      return;
    } else {
      if (oldPassword === newPassword) {
        setSnackBarMessage("Las contraseñas no pueden ser iguales, por favor intente de nuevo");
        setSnackBarOpen(true);
        setLoadingChangePassword(false);
        return;
      } else if (newPassword !== confirmNewPassword) {
        setSnackBarMessage("La nueva contraseña no coincide con la confirmación, por favor intente de nuevo");
        setSnackBarOpen(true);
        setLoadingChangePassword(false);
        return;
      } else {
        makeRequest(
          "PUT",
          `users/password`,
          {
            old_password: oldPassword,
            new_password: newPassword,
          },
          "application/json",
          localStorage.getItem("token"),
          localStorage.getItem("tokenType"),
          () => {
            navigate("/login");
          }
        )
          .then((response) => {
            console.log(response);
            setSnackBarMessage("Contraseña cambiada correctamente");
            setSnackBarOpen(true);
            setOpenDialog(false);
            setLoadingChangePassword(false);
          })
          .catch((error) => {
            console.log("Error al cambiar la contraseña");
            setSnackBarMessage("Error al cambiar la contraseña");
            setSnackBarOpen(true);
            setLoadingChangePassword(false);
          });
      }
    }
  };

  // Función que construye el contenido del Drawer (menú lateral)
  const list = () => (
    <>
      <DrawerHeader>
        <Box component="img" src={LogoLogo} alt="Logo" />
      </DrawerHeader>

      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {pagesActiveView.map((text, index) => {
          const isAdminRestaurant = text === "Admin. Restaurante";
          return (
            <React.Fragment key={text}>
              <ListItem
                disablePadding
                sx={{
                  borderRadius: "12px",
                  marginTop: index === 0 ? "50px" : "36px",
                  maxWidth: "250px",
                  transition: "background 0.3s ease",
                  height: "44px",
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  paddingBottom: "4px",
                  paddingTop: "4px",
                  border: text === "Calls" ? "1px solid #D8D8D8" : "none",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.04)",
                  },
                }}
              >
                <ListItemButton
                  onClick={() => {
                    setActiveView(text);
                    if (isAdminRestaurant) {
                      setAdminTabsOpen((prev) => !prev);
                    }
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "16px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <ListItemIcon
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "40px",
                      }}
                    >
                      {text === "Usuarios" && <PersonIcon sx={{ color: "black" }} />}
                      {text === "Restaurantes" && <RestaurantIcon sx={{ color: "black" }} />}
                      {text === "Admin. Restaurante" && <RestaurantIcon sx={{ color: "black" }} />}

                      {text === "Calls" && (
                        <Box
                          component="img"
                          src={PhoneFlip}
                          alt="Phone Flip"
                          sx={{
                            width: 22,
                            height: 22,
                            filter:
                              "brightness(0) saturate(100%) invert(18%) sepia(98%) saturate(3265%) hue-rotate(338deg) brightness(93%) contrast(94%)",
                          }}
                        />
                      )}
                      {text === "Estadísticas" && <BarChartIcon sx={{ color: "black" }} />}
                      {text === "Ajustes" && <SettingsIcon sx={{ color: "black" }} />}
                      {text === "Planes" && <WorkspacePremiumIcon sx={{ color: "#6366f1" }} />}
                    </ListItemIcon>

                    <ListItemText
                      sx={{
                        color: text === "Calls" ? "#F72E41" : text === "Planes" ? "#6366f1" : "black",
                      }}
                      primary={text}
                    />
                  </Box>

                  {isAdminRestaurant && selectedRestaurant && (
                    <ExpandMoreIcon
                      sx={{
                        transform: adminTabsOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease",
                        color: "#1E1E1E",
                      }}
                    />
                  )}
                </ListItemButton>
              </ListItem>

              {isAdminRestaurant && selectedRestaurant && (
                <Collapse in={adminTabsOpen} timeout="auto" unmountOnExit>
                  {[
                    { text: "Usuarios", icon: <PersonIcon /> },
                    { text: "Mesas", icon: <TableChartIcon /> },
                    { text: "Menú", icon: <MenuBookIcon /> },
                    { text: "Productos", icon: <LocalMallIcon /> },
                    { text: "Categorias", icon: <CategoryIcon /> },
                    { text: "Agenda", icon: <CalendarTodayIcon /> },
                    { text: "Reservas", icon: <Badge badgeContent={reservationsBadgeCount} color="error" max={99}><EventNoteIcon /></Badge> },
                    { text: "Imágenes", icon: <ImageIcon /> },
                    { text: "Linktree", icon: <LinkIcon /> },
                    { text: "Encuestas", icon: <AssignmentIcon /> },
                    { text: "Crear Restaurante", icon: <AddCircleOutlineIcon /> }
                  ]
                  .filter(({ text }) => text !== "Crear Restaurante" || localStorage.getItem("has_billing_account") === "true")
                  .map(({ text, icon }) => (
                    <ListItem
                      key={text}
                      disablePadding
                      sx={{
                        borderRadius: "12px",
                        marginTop: "8px",
                        maxWidth: "220px",
                        ml: 4,
                        transition: "background 0.3s ease",
                        height: "40px",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                        "&:hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      }}
                    >
                      <ListItemButton
                        onClick={() => {
                          if (text === "Crear Restaurante") {
                            setCreateModalOpen(true);
                          } else {
                            if (text === "Reservas" && reservationsBadgeCount > 0) {
                              setReservationsBadgeCount(0);
                            }
                            setProductFilter("");
                            setImageFilter("");
                            setAdminActiveTab(text);
                            setActiveView("Admin. Restaurante");
                          }
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "16px",
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "40px",
                            color: "#1E1E1E",
                          }}
                        >
                          {icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={text}
                          sx={{
                            color: "black",
                            "& .MuiListItemText-primary": {
                              fontFamily: "Como, sans-serif",
                              fontSize: 14,
                              fontWeight: 500,
                            },
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </Collapse>
              )}
            </React.Fragment>
          );
        })}

        {/* 🔹 NUEVO BOTÓN: Seleccionar Restaurante */}
        <Divider sx={{ width: "100%", my: 2, borderColor: "#D8D8D8" }} />
        <ListItem
          disablePadding
          sx={{
            borderRadius: "12px",
            maxWidth: "250px",
            transition: "background 0.3s ease",
            height: "44px",
            paddingLeft: "8px",
            paddingRight: "8px",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          }}
        >
          <ListItemButton
            onClick={() => setOpenRestaurantPopup(true)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <ListItemIcon
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "40px",
              }}
            >
              <RestaurantIcon sx={{ color: "black" }} />
            </ListItemIcon>
            <ListItemText
              primary="Seleccionar Restaurante"
              sx={{
                color: "black",
                "& .MuiListItemText-primary": {
                  fontFamily: "Como, sans-serif",
                  fontSize: 14,
                  fontWeight: 500,
                },
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {/* Popup para seleccionar restaurante (controlado por openRestaurantPopup) */}
      <SelectRestaurantPopup
        open={openRestaurantPopup}
        setOpen={setOpenRestaurantPopup}
        onSelect={(restaurant) => {
          setSelectedRestaurant(restaurant);
          setCurrentRestaurantId(restaurant.id); // Actualizar el ID para el WebSocket
          setOpenRestaurantPopup(false);
          setAdminTabsOpen(true);
        }}
      />

      <AppBar
        position="fixed"
        open={width > 900}
        sx={{
          backgroundColor: "white",
          color: "#1E1E1E",
          boxShadow: "0px 4px 16px rgba(0,0,0,0.06)",
          borderRadius: "16px",
          border: "2px solid #D8D8D8",
          p: 0,
          "@media (max-width:900px)": {
            marginTop: "10px",
            borderRadius: "0 0 12px 12px",
          },
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            minHeight: "72px",
            px: "16px",
          }}
        >
          {/* 🔹 Izquierda: menú o título y restaurante */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {width < 900 && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                sx={{ color: "#1E1E1E" }}
              >
                <MenuIcon />
              </IconButton>
            )}

            {width > 900 ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {selectedRestaurant && (
                  <>
                    <RestaurantIcon sx={{ color: '#1E1E1E', fontSize: 20 }} />
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: 'Como, sans-serif',
                        fontWeight: 500,
                        color: '#1E1E1E',
                        backgroundColor: '#f0f0f0',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: '20px',
                        fontSize: 14,
                      }}
                    >
                      {selectedRestaurant.name}
                    </Typography>
                    <IconButton size="small" onClick={() => { setNewRestaurantName(selectedRestaurant.name); setOpenEditNameDialog(true); }}>
                       <EditIcon fontSize="small" sx={{ color: '#1E1E1E' }} />
                    </IconButton>
                  </>
                )}
                <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                    fontFamily: "Como, sans-serif",
                    fontWeight: 600,
                    fontSize: 20,
                    color: "#1E1E1E",
                  }}
                >
                  {activeView}
                </Typography>
              </Box>
            ) : (
                selectedRestaurant && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <RestaurantIcon sx={{ color: '#1E1E1E', fontSize: 16 }} />
                    <Typography
                      sx={{
                        fontFamily: 'Como, sans-serif',
                        fontWeight: 700,
                        color: '#1E1E1E',
                        backgroundColor: '#f0f0f0',
                        px: 1,
                        py: 0.2,
                        borderRadius: '12px',
                        fontSize: 11,
                        maxWidth: '100px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {selectedRestaurant.name}
                    </Typography>
                    <IconButton size="small" onClick={() => { setNewRestaurantName(selectedRestaurant.name); setOpenEditNameDialog(true); }} sx={{ padding: 0.5 }}>
                       <EditIcon sx={{ color: '#1E1E1E', fontSize: 14 }} />
                    </IconButton>
                  </Box>
                )
            )}
          </Box>

            {/* 🔹 Derecha: indicadores + plan activo + notificaciones + perfil */}
            <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 2 } }}>
              
              {/* Agrupación tipo acordeón para > 1340px logic */}
              {width < 1340 ? (
                <>
                  <IconButton 
                    onClick={(e) => setAnchorElGroup(e.currentTarget)}
                    sx={{ 
                      bgcolor: 'rgba(0,0,0,0.03)', 
                      borderRadius: '12px',
                      color: '#1E1E1E'
                    }}
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorElGroup}
                    open={Boolean(anchorElGroup)}
                    onClose={() => setAnchorElGroup(null)}
                    PaperProps={{
                      sx: {
                        mt: 1.5,
                        p: 2,
                        borderRadius: '16px',
                        border: '1px solid #D8D8D8',
                        boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
                        minWidth: '280px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                       <Typography variant="subtitle2" sx={{ fontWeight: 700, px: 1, color: '#666' }}>Resumen de Suscripción</Typography>
                       <Box sx={{ p: 1, bgcolor: '#f9f9f9', borderRadius: '12px' }}>
                          <UsageIndicators />
                       </Box>
                       <Divider />
                       <Box sx={{ px: 1 }}>
                          {planTier && (() => {
                            const PLAN_CHIP = {
                              trial:      { label: "Prueba",     bg: "#e0f2fe", color: "#0284c7", icon: "🎁", border: "#bae6fd" },
                              basic:      { label: "Básico",     bg: "#f0f0f0",                    color: "#475569", icon: "🌱", border: "#D8D8D8" },
                              pro:        { label: "Pro",          bg: "rgba(247,46,65,0.08)",       color: "#c41730", icon: "⚡",   border: "rgba(247,46,65,0.25)" },
                              enterprise: { label: "Enterprise",   bg: "rgba(245,158,11,0.10)",     color: "#b45309", icon: "🏆",   border: "rgba(245,158,11,0.3)" },
                            };
                            const chip = PLAN_CHIP[planTier] || PLAN_CHIP.basic;
                            return (
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: 'space-between',
                                  gap: "10px",
                                  background: chip.bg,
                                  border: `1px solid ${chip.border}`,
                                  borderRadius: "12px",
                                  px: "15px",
                                  py: "10px",
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <span style={{ fontSize: "16px" }}>{chip.icon}</span>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 700, color: chip.color }}>Plan {chip.label}</Typography>
                                </Box>
                                <Typography sx={{ fontSize: '10px', color: '#666', fontWeight: 600 }}>ACTIVO</Typography>
                              </Box>
                            );
                          })()}
                       </Box>
                    </Box>
                  </Menu>
                </>
              ) : (
                <>
                  <UsageIndicators />
                  {planTier && (() => {
                    const PLAN_CHIP = {
                      trial:      { label: "Prueba",     bg: "#e0f2fe", color: "#0284c7", icon: "🎁", border: "#bae6fd" },
                      basic:      { label: "Básico",     bg: "#f0f0f0",                    color: "#475569", icon: "🌱", border: "#D8D8D8" },
                      pro:        { label: "Pro",          bg: "rgba(247,46,65,0.08)",       color: "#c41730", icon: "⚡",   border: "rgba(247,46,65,0.25)" },
                      enterprise: { label: "Enterprise",   bg: "rgba(245,158,11,0.10)",     color: "#b45309", icon: "🏆",   border: "rgba(245,158,11,0.3)" },
                    };
                    const chip = PLAN_CHIP[planTier] || PLAN_CHIP.basic;
                    return (
                      <Box
                        sx={{
                          display: { xs: "none", sm: "flex" },
                          alignItems: "center",
                          gap: "5px",
                          background: chip.bg,
                          border: `1px solid ${chip.border}`,
                          borderRadius: "999px",
                          px: "10px",
                          py: "4px",
                          cursor: "default",
                          userSelect: "none",
                        }}
                      >
                        <Tooltip title={chip.label}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <span style={{ fontSize: "12px", lineHeight: 1 }}>{chip.icon}</span>
                            <Typography
                              sx={{
                                fontSize: "11px",
                                fontWeight: 700,
                                fontFamily: "Como, sans-serif",
                                color: chip.color,
                                letterSpacing: "0.04em",
                                lineHeight: 1,
                              }}
                            >
                              {chip.label}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Box>
                    );
                  })()}
                </>
              )}

            {/* Ícono de notificaciones */}
            <IconButton
              onClick={(e) => setAnchorElNotifications(e.currentTarget)}
              sx={{
                color: "#1E1E1E",
                position: "relative",
              }}
            >
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>

            {/* Menú de notificaciones */}
            <Menu
              anchorEl={anchorElNotifications}
              open={Boolean(anchorElNotifications)}
              onClose={() => setAnchorElNotifications(null)}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 320,
                  maxHeight: 400,
                  borderRadius: "12px",
                  p: 1,
                  border: "1px solid #D8D8D8",
                  boxShadow: "0px 6px 18px rgba(2, 2, 7, 0.06)",
                },
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              {notifications.length === 0 ? (
                <MenuItem disabled>No hay notificaciones</MenuItem>
              ) : (
                <>
                  <Box sx={{ display: "flex", justifyContent: "space-between", px: 2, py: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      Notificaciones
                    </Typography>
                    {unreadCount > 0 && (
                      <Typography
                        variant="caption"
                        sx={{ color: "#796DB8", cursor: "pointer" }}
                        onClick={markAllAsRead}
                      >
                        Marcar todas como leídas
                      </Typography>
                    )}
                  </Box>
                  <Divider />
                  <NotificationList dense sx={{ maxHeight: 300, overflow: "auto" }}>
                    {notifications.map((notif) => (
                      <MenuItem
                        key={notif.id}
                        onClick={() => handleNotificationClick(notif)}
                        sx={{
                          backgroundColor: notif.read ? "transparent" : "rgba(121, 109, 184, 0.08)",
                          "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
                        }}
                      >
                        <ListItemAvatar>
                          <NotificationAvatar src={notif.image_url} sx={{ width: 40, height: 40, borderRadius: "8px" }}>
                            <ImageIcon />
                          </NotificationAvatar>
                        </ListItemAvatar>
                        <NotificationListItemText
                          primary={notif.name}
                          secondary={
                            <>
                              <Typography variant="caption" color="textSecondary">
                                {new Date(notif.timestamp).toLocaleTimeString()}
                              </Typography>
                              <br />
                              <Typography variant="body2" noWrap>
                                Imagen mejorada con IA
                              </Typography>
                            </>
                          }
                        />
                      </MenuItem>
                    ))}
                  </NotificationList>
                </>
              )}
            </Menu>

            {/* Perfil */}
            <Box
              onClick={handleMenu}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.2,
                backgroundColor: "white",
                borderRadius: "9999px",
                padding: "9px 14px",
                boxShadow: "0px 3px 10px rgba(0,0,0,0.08)",
                cursor: "pointer",
                transition: "all 0.2s ease",
                border: "1px solid #D8D8D8",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                },
              }}
            >
              <Avatar
                alt="Profile"
                sx={{
                  width: 32,
                  height: 32,
                  bgcolor: "#E53935",
                  fontFamily: "Como, sans-serif",
                  fontSize: 14,
                  textTransform: 'uppercase',
                }}
              >
                {userName ? userName.charAt(0) : 'U'}
              </Avatar>

              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Typography
                  sx={{
                    color: "#1E1E1E",
                    fontSize: 16,
                    fontFamily: "Como, sans-serif",
                    fontWeight: 600,
                    lineHeight: 1.1,
                  }}
                >
                  {userName}
                </Typography>
                <Typography
                  sx={{
                    color: "#796DB8",
                    fontSize: 12,
                    fontFamily: "Como, sans-serif",
                    fontWeight: 500,
                  }}
                >
                  Mi Cuenta
                </Typography>
              </Box>
            </Box>

            {/* Menú del perfil */}
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 220,
                  borderRadius: "12px",
                  p: 1,
                  border: "1px solid #D8D8D8",
                  boxShadow: "0px 6px 18px rgba(2, 2, 7, 0.06)",
                  "& .MuiMenu-list": { p: 0 },
                  bgcolor: "#FFFFFF",
                },
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              {/* Opción Cambiar contraseña */}
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  setOpenDialog(true);
                }}
                sx={{
                  px: 2,
                  py: 1,
                  gap: "16px",
                  "&:hover": { backgroundColor: "rgba(0,0,0,0.03)" },
                  color: "black",
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <LockIcon sx={{ color: "#6B7280" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Cambiar contraseña"
                  primaryTypographyProps={{
                    fontFamily: "Como, sans-serif",
                    fontWeight: 500,
                    fontSize: 14,
                  }}
                />
              </MenuItem>

              <Divider sx={{ borderColor: "#EAEAEA", my: 0.5 }} />

              {/* Opción Cerrar sesión */}
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  handleLogOut();
                }}
                sx={{
                  px: 2,
                  py: 1,
                  gap: "16px",
                  "&:hover": {
                    backgroundColor: "rgba(247,46,65,0.08)",
                  },
                  color: "black",
                }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <ExitToAppIcon sx={{ color: "#F72E41" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Cerrar sesión"
                  primaryTypographyProps={{
                    fontFamily: "Como, sans-serif",
                    fontWeight: 500,
                    fontSize: 14,
                  }}
                />
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      <DrawerCustomized
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={width < 900 ? open : true}
      >
        {list()}
      </DrawerCustomized>

      {width < 900 && (
        <SwipeableDrawer
          anchor="left"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          sx={{
            "& .MuiDrawer-paper": {
              background: "white",
              color: "black",
              borderRadius: "16px",
              margin: "10px",
              boxSizing: "border-box",
              height: "calc(100% - 20px)",
              width: drawerWidth,
              border: "2px solid #D8D8D8",
              padding: "16px",
            },
          }}
        >
          {list()}
        </SwipeableDrawer>
      )}

      <Main
        open={width > 900}
        sx={{
          marginTop: "110px",
          borderRadius: "20px",
          marginRight: "10px",
        }}
      >
        {!selectedRestaurant ? (
          <SelectRestaurantPopup
            open={!selectedRestaurant}
            onSelect={(restaurant) => {
              setSelectedRestaurant(restaurant);
              setCurrentRestaurantId(restaurant.id);
              setAdminActiveTab(null);
              setAdminTabsOpen(true);
            }}
          />
        ) : (
          renderView()
        )}
      </Main>

      <CustomDialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <CustomDialogTitle>Cambiar contraseña</CustomDialogTitle>
        <CustomDialogContent>
          {loadingChangePassword ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <CustomTextField
                autoFocus
                margin="dense"
                id="oldPassword"
                label="Antigua Contraseña"
                type="password"
                fullWidth
                onChange={(e) => setOldPassword(e.target.value)}
                value={oldPassword}
              />
              <CustomTextField
                margin="dense"
                id="newPassword"
                label="Nueva Contraseña"
                type="password"
                fullWidth
                onChange={(e) => setNewPassword(e.target.value)}
                value={newPassword}
              />
              <CustomTextField
                margin="dense"
                id="confirmPassword"
                label="Confirmar Contraseña"
                type="password"
                fullWidth
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                value={confirmNewPassword}
              />
            </>
          )}
        </CustomDialogContent>
        <CustomDialogActions>
          <SendButton
            onClick={() => {
              setLoadingChangePassword(true);
              handlePasswordChange();
            }}
          >
            Enviar
          </SendButton>
        </CustomDialogActions>
      </CustomDialog>

      {/* Snackbar para notificaciones en tiempo real */}
      <Snackbar
        open={notificationSnack.open}
        autoHideDuration={6000}
        onClose={handleCloseNotificationSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClick={() => {
          if (notificationSnack.productName) {
            setProductFilter(notificationSnack.productName);
            setActiveView("Admin. Restaurante");
            setAdminActiveTab("Productos");
            handleCloseNotificationSnack();
          }
        }}
        sx={{ cursor: "pointer" }}
      >
        <Alert
          onClose={handleCloseNotificationSnack}
          severity="success"
          icon={<AutoAwesomeIcon />}
          sx={{
            width: "100%",
            backgroundColor: "#070724",
            color: "white",
            "& .MuiAlert-icon": { color: "#F72E41" },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {notificationSnack.imageUrl && (
              <Avatar src={notificationSnack.imageUrl} sx={{ width: 40, height: 40, borderRadius: "8px" }} />
            )}
            <Typography variant="body2">{notificationSnack.message}</Typography>
          </Box>
        </Alert>
      </Snackbar>

      {/* Snackbar general */}
      {snackBarOpen && <SnackBar openSnackBar={snackBarOpen} setOpenSnackBar={setSnackBarOpen} messageSnackBar={snackBarMessage} />}
      {/* Modal de creación de restaurante desde el sidebar */}
      <CreateRestaurantModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={() => {
          setCreateModalOpen(false);
          // Puedes añadir lógica para recargar la lista de restaurantes en el popup si es necesario
        }}
        onUpgradePlan={() => setCreateModalOpen(false)}
      />
      {/* Global subscription expiration banner */}
      {localStorage.getItem("rol") === "2" && (
        <SubscriptionBanner
          onRenewClick={() => {
            setActiveView("Planes");
            // Scroll to top so the plans grid is visible immediately
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        />
      )}

      {/* Dialogo para editar nombre de restaurante */}
      <CustomDialog open={openEditNameDialog} onOpenChange={setOpenEditNameDialog}>
        <CustomDialogTitle>Editar Nombre del Restaurante</CustomDialogTitle>
        <CustomDialogContent>
          <CustomTextField
            autoFocus
            margin="dense"
            label="Nuevo Nombre"
            type="text"
            fullWidth
            value={newRestaurantName}
            onChange={(e) => setNewRestaurantName(e.target.value)}
          />
        </CustomDialogContent>
        <CustomDialogActions>
          <Button onClick={() => setOpenEditNameDialog(false)} sx={{ color: '#1E1E1E' }}>
            Cancelar
          </Button>
          <SendButton onClick={handleEditNameSubmit} disabled={loadingEditName}>
            {loadingEditName ? <CircularProgress size={24} color="inherit" /> : "Guardar"}
          </SendButton>
        </CustomDialogActions>
      </CustomDialog>
    </Box>
  );
}

export default function DashBoard({ setIsLoggedIn }) {
  return (
    <SubscriptionUsageProvider>
      <DashBoardContent setIsLoggedIn={setIsLoggedIn} />
    </SubscriptionUsageProvider>
  );
}